import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { estateSelector, setEstateInfo } from "@/domains/estate/slice";
import toast from "@/domains/toasts/helpers/toast";

export default ({ setIsShow, onSuccessSell }) => {
  const { t } = useTranslation("estate");
  const estate = useAppSelector(estateSelector);
  const dispatch = useDispatch();
  const [price, setPrice] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSelling, setIsSelling] = useState(false);

  const load = useCallback(async () => {
    setIsLoading(true);

    await EstateMpProvider.getSellPrice(estate.id)
      .then((response) => {
        if (response instanceof RpcMpProviderSuccessResponse) {
          setPrice(response.data);
        } else {
          toast.error(t(`estate.errors.${response.error.message}`));
          setIsShow(false);
        }
      })
      .catch((e) => {
        console.error(e);
        toast.error(t("estate.errors.LOAD_SELL_PRICE_ERROR"));
        setIsShow(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [estate.id, setIsShow, setIsLoading, t]);

  useEffect(() => {
    load();
  }, [load]);

  const sell = useCallback(async () => {
    setIsSelling(true);

    await EstateMpProvider.sell(estate.id)
      .then((response) => {
        if (response instanceof RpcMpProviderSuccessResponse) {
          toast.success(t("estate.successSell"));
          setIsShow(false);
          dispatch(setEstateInfo(null));
          onSuccessSell();
        } else {
          console.error(response);
          toast.error(t(`estate.errors.${response.error.message}`));
          setIsShow(false);
        }
      })
      .catch((e) => {
        console.error(e);
        toast.error(t("estate.errors.SELL_ERROR"));
        setIsShow(false);
      })
      .finally(() => {
        setIsSelling(false);
      });
  }, [t, setIsSelling, estate.id, onSuccessSell]);

  return {
    estate,
    price,
    isLoading,
    sell,
    isSelling,
  };
};
